import React, { useState } from 'react';
import { Button, Drawer } from 'ceci-ui';
import CollectionRuleForm from '../CollectionRuleForm';

const CollectionRuleDrawerButton = () => {
  const [open, setOpen] = useState<boolean>(false);

  return (
    <>
      <Button variant="outlined" onClick={() => setOpen(true)}>Regua de cobrança</Button>
      <Drawer open={open} onClose={() => setOpen(false)}>
        <CollectionRuleForm />
      </Drawer>
    </>
  )
};

export default CollectionRuleDrawerButton;
